<template>
	<div class="img-container" :class="{'center': center, 'nomal': !center}">
		<div class="indicator" :class="{'rotate-y': indicatorDirection == 'right' && !indicatorInvert, 
			'rotate-x': indicatorDirection == 'left' && indicatorInvert,
			'rotate': indicatorDirection == 'right' && indicatorInvert}" 
			v-if="indicatorTxt" :style="indicatorStyle">
			<div class="single-line txt" @click="onClick">{{indicatorTxt}}</div>
			<img src="~@/assets/svg/indicator.svg" />
		</div>
		<template v-if="center && centerVideoUrl && (!imgUrl || isSupport)">
			<video id="video-player" class="img" muted autoplay style="object-fit: fill;">
				<source :src="centerVideoUrl" type="video/mp4" />
			</video>
		</template>
		<template v-else>
			<img class="img" :src="imgUrl" alt="" v-if="imgUrl" 
				@mouseover="onMouseover" @click="onClick" />
			<img class="img" src="~@/assets/png/six-side-img-bg.png" alt="" v-else />
		</template>
	</div>
</template>

<script>
	export default {
		name: 'SixSideImg',
		props: {
			imgUrl: {
				type: String,
				default: ''
			},
			center: {
				type: Boolean,
				default: false
			},
			centerVideoUrl: {
				type: String,
				default: ''
			},
			indicatorTxt: {
				type: String,
				default: ''
			},
			indicatorDirection: {
				type: String,
				default: 'left'
			},
			indicatorInvert: {
				type: Boolean,
				default: false
			}
			
		},
		data() {
			return {
				videoDom: undefined,
				isSupport: true,
			}
		},
		computed: {
			indicatorStyle() {
				if(this.indicatorDirection == 'left' && !this.indicatorInvert) {
					return {
						bottom: 'calc(var(--s) / 3)',
						right: 'calc(var(--s) / 5 * 3)',
						transformOrigin: '100% 100%'
					}
				}else if(this.indicatorDirection == 'right' && !this.indicatorInvert) {
					return {
						bottom: 'calc(var(--s) / 3)',
						left: 'calc(var(--s) / 5 * 3)',
						transformOrigin: '0% 100%'
					}
				}else if(this.indicatorDirection == 'left' && this.indicatorInvert) {
					return {
						top: 'calc(var(--s) / 3)',
						right: 'calc(var(--s) / 5 * 3)',
						transformOrigin: '100% 0%'
					}
				}else if(this.indicatorDirection == 'right' && this.indicatorInvert) {
					return {
						top: 'calc(var(--s) / 3)',
						left: 'calc(var(--s) / 5 * 3)',
						transformOrigin: '0% 0%'
					}
				}
				
			}
		},
		watch: {
			centerVideoUrl: {
			  handler(nVal, oVal) {
				  if(this.center && nVal && !oVal) {
					  this.$nextTick(() => {
					  	this.videoDom = document.getElementById('video-player');
						this.videoDom.play().then(() => {
							console.log('视频自动播放成功')
							this.isSupport = true;
						}).catch((error) => {
							console.log("视频自动播放失败: " + error);
							this.isSupport = false;
						});
						this.videoDom.addEventListener('play', () => {
							console.log('=======play')
							//this.isPlay = true;
						});
					  	this.videoDom.addEventListener('ended', () => {
					  	  this.$emit("update:centerVideoUrl", "");
						  //this.isPlay = false;
					  	});
					  });
				  }else if(this.center && nVal && oVal && this.videoDom) {
					  this.$nextTick(() => {
					  	this.videoDom.load();
					  });
				  }
			  }
			}
		},
		mounted() {
			
		},
		methods: {
			onMouseover() {
				this.$emit("mouseover");
			},
			onClick() {
				this.$emit("click");
			}
		}
	}
</script>

<style lang="less" scoped>
	.img-container {
		display: block;
		height: var(--s);
		grid-area: 1/1;
		aspect-ratio: calc(sqrt(3) / 2);
		transform: translate(var(--_x, 0), var(--_y, 0));
		position: relative;
	}
	div, video {
		//border: 1px solid #000000;
	}
	.indicator {
		z-index: 0;
		position: absolute;
		transform: scale(var(--scale-rate));
		.txt {
			width: 60%;
			font-size: var(--inc-txt-size, 24px);
			cursor: pointer;
			z-index: 10;
		}
		img {
			width: 300px;
			height: 90px;
			z-index: 6;
		}
	}
	
	.rotate-y {
		.txt {
			margin-left: 50%;
		}
		img {
			transform: rotateY(180deg);
		}
	}
	
	.rotate-x {
		.txt {
			position: absolute;
			top: 55px;
		}
		img {
			transform: rotateX(180deg);
		}
	}
	
	.rotate {
		.txt {
			margin-left: 50%;
			position: absolute;
			top: 55px;
		}
		img {
			transform: rotate(180deg);
		}
	}
	
	.img {
		z-index: 99;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background-color: rgb(49, 75, 137);
		grid-area: 1/1;
		/* 规定从第一行第一列开始显示项目 */
		height: var(--s);
		//aspect-ratio: 1.15;
		aspect-ratio: calc(sqrt(3) / 2);
		/* 宽高比例缩放 */
		object-fit: cover;
		/* 保持图片原有比例, 会有剪切*/
		//clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0 50%);
		clip-path: polygon(0% 25%, 50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%);
		transform: scale(var(--_t, 1));
		/* 对图片进行移动和缩放 */
		cursor: pointer;
		//filter: grayscale(80%);
		/* 灰度滤镜 */
		transition: 0.2s linear;
		/* 过渡效果 */
	}
	.center {
		.img {
			--_t: 1.4;
		}
	}
	.nomal {
		.img:hover {
		  filter: grayscale(0);
		  --_t: 1.2;
		}
	}
	.nomal:hover {
		z-index: 100;
	}
</style>